/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FirmwareUpdateState } from '../../models/firmware-update-state';
import { PageDto } from '../../models/page-dto';
import { RouterSorting } from '../../models/router-sorting';
import { Sorting } from '../../models/sorting';
import { VpnLinkedState } from '../../models/vpn-linked-state';

export interface GetAllRouters$Params {

/**
 * Filter by ID of crane
 */
  craneId?: string;

/**
 * Filter by user that allowed the firmware update
 */
  fwDownloadAllowedBy?: string;

/**
 * Filter by firmware version to download
 */
  fwDownloadVersion?: string;

/**
 * Filter by state of firmware update
 */
  fwUpdateState?: FirmwareUpdateState;

/**
 * Filter by installed firmware version
 */
  fwVersion?: string;

/**
 * Filter if the routers returned have to have a simcard
 */
  hasSimcard?: boolean;

/**
 * Filter if the routers returned should be online (true) of offline (false)
 */
  isOnline?: boolean;

/**
 * The index of requested page. The first page's index is 0
 */
  page?: number;

/**
 * The requested amount of pages. The amount of total pages depends on this value
 */
  pageSize?: number;

/**
 * Filter by id
 */
  routerId?: string;

/**
 * Filter by routerType id
 */
  routerTypeId?: number;

/**
 * Filter by searching for given search term. Searches in serialNumber and craneId.
 */
  searchTerm?: string;

/**
 * Filter by serial number
 */
  serialNumber?: string;

/**
 * Filter routers by servicePath aka organizational unit.
 */
  servicePath?: string;

/**
 * The sort direction of the list
 */
  sort?: Sorting & any;

/**
 * Sort by field, default by ID
 */
  sortBy?: RouterSorting & any;

/**
 * Filter routers by vpnIp address.
 */
  vpnIp?: string;

/**
 * Filter by device vpn state
 */
  vpnState?: VpnLinkedState;
}

export function getAllRouters(http: HttpClient, rootUrl: string, params?: GetAllRouters$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDto>> {
  const rb = new RequestBuilder(rootUrl, getAllRouters.PATH, 'get');
  if (params) {
    rb.query('craneId', params.craneId, {});
    rb.query('fwDownloadAllowedBy', params.fwDownloadAllowedBy, {});
    rb.query('fwDownloadVersion', params.fwDownloadVersion, {});
    rb.query('fwUpdateState', params.fwUpdateState, {});
    rb.query('fwVersion', params.fwVersion, {});
    rb.query('hasSimcard', params.hasSimcard, {});
    rb.query('isOnline', params.isOnline, {});
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('routerId', params.routerId, {});
    rb.query('routerTypeId', params.routerTypeId, {});
    rb.query('searchTerm', params.searchTerm, {});
    rb.query('serialNumber', params.serialNumber, {});
    rb.query('servicePath', params.servicePath, {});
    rb.query('sort', params.sort, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('vpnIp', params.vpnIp, {});
    rb.query('vpnState', params.vpnState, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageDto>;
    })
  );
}

getAllRouters.PATH = '/routers';
